import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import {
  adminPassword,
  adminUsername,
  barbersLimitedRegistrationApiUrl,
} from '../../config';
import JSONbigNative from 'json-bigint';
import { ShopSubscription } from '../../types/shop';
import { BarberSubscription } from '../../types/barber';
import {
  CreateStripeCustomerParams,
  StripeSubscriptionParams,
  UpdateStripeCustomerParams,
  UpdateStripeSubscriptionParams,
} from '../../types/stripePayments';

const JSONbig = JSONbigNative({ useNativeBigInt: true });

const response = [
  (data: any) => {
    if (typeof data === 'string') {
      try {
        data = JSONbig.parse(data);
      } catch (e) {
        console.error(e);
      }
    }
    return data;
  },
];

export const RegisterBarber = async (
  formField: Record<string, any>
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/barbers`,
    data: formField,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const RegisterShopOwner = async (
  formField: Record<string, any>
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/shopOwners`,
    data: formField,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const createShopSubscription = async (
  formField: ShopSubscription
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/shopSubscriptions`,
    data: JSONbig.stringify(formField),
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const createBarberSubscription = async (
  formField: BarberSubscription
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/barberSubscriptions`,
    data: JSONbig.stringify(formField),
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const cancelSubscription = async (
  subscriptionId: string,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/cancel-subscription`,
    data: JSON.stringify({ subscriptionId }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const createStripeCustomer = async (
  params: CreateStripeCustomerParams
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/stripe/customers`,
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const updateStripeCustomer = async (
  customerId: string,
  param: UpdateStripeCustomerParams,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/stripe/customers/update/${customerId}`,
    data: JSON.stringify(param),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const detachPaymentMethod = async (
  paymentMethodId: string,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/stripe/payment-methods/detach/${paymentMethodId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const createSetupIntentForCustomer = async (
  customerId: string,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/stripe/customers/${customerId}/setup-intent`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const createStripeSubscription = async (
  subscriptionPayload: StripeSubscriptionParams
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/stripe/create-subscription`,
    data: JSON.stringify(subscriptionPayload),
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const updateStripeSubscription = async (
  subscriptionId: string,
  subscriptionPayload: UpdateStripeSubscriptionParams,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedRegistrationApiUrl}/stripe/update-subscription/${subscriptionId}`,
    data: JSON.stringify(subscriptionPayload),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    transformResponse: response,
  };
  return axios.request(config);
};
